/* 
 * @author Lucky
 * @description This function will add query string to anchor tags within .st-mod-href CSS class
 * @version v1.0
 */

const currentURL = new URLSearchParams(window.location.search);
const urlParams = Object.fromEntries(currentURL.entries());

var links = document.querySelectorAll('.st-mod-href a');
for (var x = 0; x < links.length; x++) {
    var link = links[x];
    var btnUrlStr = link.getAttribute('href');
    var btnUrl = new URL(link.getAttribute('href'));
    var params = new URLSearchParams(btnUrl.search);
    for (var attr in urlParams) {
        params.set(attr, urlParams[attr]);
    }
    
    var tracking_url = stripTrailingSlash(btnUrlStr.split('?')[0]) + '/?' + params.toString();
    link.setAttribute('href', tracking_url);
}

function stripTrailingSlash(str) {
    if(str.substr(-1) === '/') {
        return str.substr(0, str.length - 1);
    }
    return str;
}